export function attachMeta<TMeta extends object, T extends object>(data: T, meta: TMeta): T & { $meta: TMeta } {
  data['$meta'] = meta as TMeta;

  return data as T & { $meta: TMeta };
}
